import React, { useRef } from "react";
import lang from "../utils/languageConstants";
import { useDispatch, useSelector } from "react-redux";
import ai from "../utils/geminiai";
import { API_OPTIONS } from "../utils/constants";
import { addGeminiMovieResult } from "../utils/gptSlice";

const GptSearchBar = () => {
  const dispatch = useDispatch();
  const langKey = useSelector((store) => store.config.lang);

  const searchText = useRef(null);

  // const handleGeminiSearchClick = async () => {
  //   console.log(searchText.current.value);

  //   const userQuery = searchText.current?.value;

  //   // Make an API call to gemini API and get movie results

  //   const geminiResults = await ai.models.generateContent({
  //     model: "gemini-2.0-flash",
  //     contents: userQuery,
  //   });

  //   console.log(geminiResults.text);
  // };

  // search movie in tmdb
  const searchMovieTMDB = async (movie) => {
    const data = await fetch(
      "https://api.themoviedb.org/3/search/movie?query=" +
        movie +
        "&include_adult=false&language=en-US&page=1",
      API_OPTIONS,
    );
    const json = await data.json();

    return json.results;
  };

  const handleGeminiSearchClick = async () => {
    const queryText = searchText.current?.value;
    const promptText = `Suggest 5 popular movies for the query: "${queryText}". Return only a comma-separated list and the example result given ahead. Example Result: Gadar, Sholay, Don, Golmaal, Koi Mil Gaya`;
    //Make an API call to gemini API and get movie results

    const geminiResults = await ai.models.generateContent({
      model: "gemini-3.5-flash",
      contents: promptText, // Pass the string directly
    });

    if (!geminiResults.text) {
      // ToDO: Write error handeling
      console.error("Gemini did not return any movies");
      return;
    }

    console.log(geminiResults.text);

    const getMovies = geminiResults.text.split(",");

    // For each movie I will search TMDB API

    const promiseArray = getMovies.map((movie) => searchMovieTMDB(movie));
    const tmdbResults = await Promise.all(promiseArray);

    console.log(tmdbResults);

    dispatch(
      addGeminiMovieResult({ movieName: getMovies, movieResults: tmdbResults }),
    );
  };

  return (
    <div className="pt-[35%] md:pt-[10%] flex justify-center ">
      <form
        className="w-full md:w-1/2 bg-black grid grid-cols-12"
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          ref={searchText}
          type="text"
          className="p-4 m-4 col-span-9"
          placeholder={lang[langKey].gptSearchPlaceholder}
        />
        <button
          className=" col-span-3 m-4 py-2 px-4  bg-red-700 text-white rounded-lg"
          onClick={handleGeminiSearchClick}
        >
          {lang[langKey].search}
        </button>
      </form>
    </div>
  );
};

export default GptSearchBar;
